<template>
  <div class="fundingProductDetail ">
    <div v-if="!isFinshedFunding" class="detailTitle">
      <h2>{{ funding.remainSalesDay === 0 ? '오늘 주문 마감': '주문 종료' }}<!--
      --><template v-if="funding.remainSalesDay > 0"><!--
        --><strong class="remainDate">{{ funding.remainSalesDay }}</strong>일 남음<!--
      --></template><!--
      --><span class="endDate">{{ `${funding.endSalesDate} 까지`}}</span></h2>
      <button class="btn btn_refresh" @click="$emit('refreshFundingInfo')"><i class="icon iconRefresh"></i></button>
    </div>
    <div v-else class="detailTitle">
      <h2 class="fundingResult">{{ isFundingSuccess ? '목표달성' : '주문 종료' }}<!--
     --><span class="badge fundingBadge" :class="isFundingSuccess ?'_isSuccess':'_isFail'">
          {{ isFundingSuccess ? '펀딩성공' : '펀딩실패' }}
        </span>
        <span v-if="!isFundingSuccess" class="endDate">{{ `${funding.endSalesDate} 까지`}}</span>
      </h2>
    </div>

    <div class="fundingProcessBox" :class="isFinshedFunding && !isFundingSuccess ? 'funding_fail':''">
      <div class="progressLabels">
        <p class="orderCount"><span>{{ `${funding.soldQuantity.toLocaleString()}개`}}</span> 주문</p>
        <p class="goalCount">목표개수 <span>{{ `${funding.targetQuantity.toLocaleString()}개`}}</span></p>
      </div>

      <progress class="fundingProgressBar" id="funding" :value="funding.soldQuantity" :max="funding.targetQuantity"></progress>

    </div>

    <div class="descListWrap" v-if="!isFinshedFunding">
      <h3 class="descListTitle">
        <!-- TODO : 체크되지 않으면 구매하기  버튼 클릭 시 알럿  -->
        <form-checkbox
          id="agree"
          labelText="구매 시 유의사항을 모두 확인했습니다."
          :checked="fundingAgree"
          @handleCheck="$emit('handleCheckFunding')"
          required
        ></form-checkbox>
      </h3>
      <ul class="descList">
        <li>목표개수에 도달하지 않을 경우 주문은  자동으로 취소됩니다.</li>
        <li>목표달성 후 제작되는 상품으로 주문 취소는 판매 종료전까지만 가능하며, 판매기간이 지난 후에는 취소가 불가합니다.</li>
        <li>결제 후 바로 배송되는 상품이 아닙니다.</li>
      </ul>
    </div>
    <div class="descListWrap" v-else>
      <ul class="descList">
        <li>목표개수에 도달하지 않을 경우 주문은  자동으로 취소됩니다.</li>
        <li>목표달성 후 제작되는 상품으로 주문 취소는 판매 종료전까지만 가능하며, 판매기간이 지난 후에는 취소가 불가합니다.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import FormCheckbox from "@/views/base/FormCheckbox";

export default {
  props: {
    funding: null,
    fundingAgree: {
      type: Boolean,
      default: false
    },
    productStatus: 0
  },
  components: {
    FormCheckbox,
  },
  computed: {
    isFinshedFunding() {
      const now = new Date().getTime();
      const end = new Date(this.funding.endSalesDate).getTime();

      if(this.productStatus === 3 || this.productStatus === 4) {
        return true;
      }

return this.funding.remainSalesDay <= 0 && now >= end;
    },
    isFundingSuccess() {
      return this.funding.soldQuantity >= this.funding.targetQuantity;
    }
  },
}

</script>

<style scoped>
</style>
